import React from "react";
import FilterContext from "../../../routes/FilterContext";
import { apiMiddleware } from "../../../services/apis/apiMiddleware";
import "jspdf-autotable";
import { connect } from "react-redux";
import { PDFReader } from "reactjs-pdf-reader";
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
export const BodyAsFormData1 = (filter) => {
  var body = new FormData();
  body.append("creID", filter);
  body.append("screener", "lease");
  return body;
};
class LeaseDeed extends React.Component {
  static contextType = FilterContext;

  state = {
    filters: "",
    creId: "",
    filterData: [],
    showLoader: true,
  };

  componentDidMount() {
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    this.state.filters = filters;
    this.getPdfUrl();
  }

  getPdfUrl() {
    this.setState({ filterData: this.props.filters }, () => {
      for (let i = 0; i < this.state.filterData.creid.length; i++) {
        apiMiddleware
          .post(
            "api/screener/view-document",
            BodyAsFormData1(this.state.filterData.creid[i].value)
          )
          .then((res) => {
            this.setState({ unitRents: res.data }, () => {
              console.log(this.state.unitRents[0]);
            });
          });
      }
    });
  }

  componentDidUpdate() {
    // if (this.props.filters != this.state.filters){
    //   this.setState({ filters: this.props.filters });
    //   apiMiddleware
    //     .post("api/screener/view-document", BodyAsFormData1(this.state.creId))
    //     .then((res) => {
    //       this.setState({ unitRents: res.data });
    //     });
    //   console.log(this.state.unitRents);
    // }
  }

  render() {
    return (
      <div className="container-fluid unitsRents">
        <div className="row">
          {this.state.unitRents ==
            "You are not allowed to download the document. Please contact CRE Matrix Team for further assistance." && (
            <div className="col-lg-12">
              <p>
                You are not allowed to download the document. Please contact CRE
                Matrix Team for further assistance
              </p>
            </div>
          )}
          {this.state.unitRents !=
            "You are not allowed to download the document. Please contact CRE Matrix Team for further assistance." &&
            this.state.unitRents != undefined && (
              <div
                className="col-lg-12"
                style={{ overflow: "scroll", height: 600 }}
              >
                {this.state.showLoader && (
                  <div className="row">
                    <div className="col-lg-12 text-center">
                      <img src="/edge/images/edgeLoader.gif" />
                    </div>
                  </div>
                )}
                <PDFReader
                  onDocumentComplete={() => {
                    this.setState({ showLoader: false });
                  }}
                  showAllPage={true}
                  url={this.state.unitRents.request}
                />
              </div>
            )}
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(LeaseDeed);
